import { render, staticRenderFns } from "./historyDialog.vue?vue&type=template&id=23a7570e"
import script from "./historyDialog.vue?vue&type=script&lang=js"
export * from "./historyDialog.vue?vue&type=script&lang=js"
import style0 from "./historyDialog.vue?vue&type=style&index=0&id=23a7570e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports